import simpleGit from 'simple-git'
import path from 'path'
import fetch from 'node-fetch'

const REPO_PATH = path.join(__dirname, '../my-repo')
const git = simpleGit(REPO_PATH)

// ✅ 일정 주기로 `git status` 실행하여 변경 사항 감지
async function checkForChanges() {
  const status = await git.status()
  const changedFiles = [...status.modified, ...status.created]

  if (changedFiles.length > 0) {
    console.log('🔄 Git 변경 사항 감지:', changedFiles)

    // ✅ Things-Factory 파이프라인 실행
    await fetch('http://localhost:3000/api/git-process-changes', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ files: changedFiles })
    })
  }
}

// ✅ 10초마다 변경 사항 확인
setInterval(checkForChanges, 10000)
